import m from 'mithril'

export default {
  view: vnode => {
    const greenland = require('./greenland.png')
    const hvalros = require('./hvalros.png')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-12-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Møde i Thule’s fangerråd d. 20, april,1953 - før flytningen af Thulefamilierne</h3>
          <p className="log-book-text">Medlem af fangerrådet ‘Jess’:</p>
          <p className="log-book-text">Efterhånden som basen udvider sig, bliver vores fangstområder mere og mere reducerede. Enhver har erfaret, at fangsten her ved Thule bliver sløjere og sløjere - hvalrosserne er efterhånden blevet sky, skræmt af flyvemaskinerne og røgen fra de brændende amerikanske affaldsbunker samt den megen spildolie på vandoverfladen. Remmesæler fanges nu i meget mindre grad end for blot få år siden.</p>
        
          <figure className="log-book-figure">
            <img src={hvalros} className="log-book-img" />  
            <figcaption className="log-book-figcaption">
              Hvalrosfangst
            </figcaption>          
          </figure>

          <figure className="log-book-figure">
            <img src={greenland} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Kort over Thule-området, de amerikanske baser og den ny bygd ‘Kanak’, som thulefamilierne er blevet flyttet til
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
